import React, { useState } from "react";
import { motion } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PortfolioModal from "./PortfolioModal";

import ringCamera from "../images/projects/ring_camera.webp";
import campusConnect from "../images/projects/campus_connect.webp";
import djangoWebApp from "../images/projects/django_web_app.webp";
import geneticAlgorithm from "../images/projects/genetic_algorithm.webp";
import musicDatabase from "../images/projects/music_database.webp";
import pokemonMobile from "../images/projects/pokemon_mobile.webp";
import spamDetection from "../images/projects/spam_detection.webp";

import projectsData from "../data/portfolio/projects.json";

function Portfolio() {
	const [selectedProject, setSelectedProject] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);

	const projectImages = {
		ringCamera,
		campusConnect,
		djangoWebApp,
		geneticAlgorithm,
		musicDatabase,
		pokemonMobile,
		spamDetection
	};

	const handleProjectClick = (project) => {
		setSelectedProject(project);
		setIsModalOpen(true);
	};
	const handleCloseModal = () => {
		setIsModalOpen(false);
		setSelectedProject(null);
	};

	return (
		<div className="min-h-screen px-4 sm:px-6 lg:px-8 py-24">
			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				className="max-w-7xl mx-auto"
			>
				<h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4 text-center text-white">
					My Projects
				</h1>
				<p className="text-gray-400 text-center mb-12 sm:mb-16 text-base sm:text-lg px-4">
					Here are some of my recent works
				</p>

				<div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
					{projectsData.map((project, index) => (
						<motion.div
							key={project.id || index}
							initial={{ opacity: 0, y: 30 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ delay: index * 0.1 }}
							whileHover={{ y: -10 }}
							className="group relative cursor-pointer"
							onClick={() => handleProjectClick(project)}
						>
							<div className="absolute inset-0 bg-white/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-20 transition-opacity"></div>
							<div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-4 sm:p-6 hover:border-white/30 transition-all duration-300 h-full flex flex-col">
								<div className="w-full aspect-[16/10] rounded-lg mb-4 sm:mb-6 overflow-hidden flex-shrink-0 bg-white/10">
									<LazyLoadImage
										src={projectImages[project.image]}
										alt={project.name}
										effect="opacity"
										wrapperClassName="w-full h-full"
										className="w-full h-full object-cover object-center transform-gpu"
										decoding="async"
									/>
								</div>
								<h3 className="text-xl sm:text-2xl font-bold text-white mb-2 sm:mb-3">
									{project.name}
								</h3>
								<p className="text-gray-400 text-sm sm:text-base mb-3 sm:mb-4 flex-grow line-clamp-2">
									{project.description}
								</p>
								<button className="w-full py-2.5 sm:py-3 bg-white text-slate-900 rounded-lg text-sm sm:text-base font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
									View Project
								</button>
							</div>
						</motion.div>
					))}
				</div>
			</motion.div>

			{selectedProject && (
				<PortfolioModal
					isOpen={isModalOpen}
					onClose={handleCloseModal}
					project={selectedProject}
					projectImages={projectImages}
				/>
			)}
		</div>
	);
}

export default Portfolio;
